import styled from "styled-components";

const c = {
  ink: "#0b0b0b",
  paper: "#ffffff",
  gold: "#c9a227",
  pink: "#fc9ac4",
};

export const MapWrap = styled.section`
  position: relative;
  width: 100%;
  height: clamp(320px, 50svh, 560px);
  overflow: hidden;

  .map,
  .leaflet-container {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100% !important;
    min-height: 280px;
  }

  @media (max-width: 720px) {
    height: clamp(300px, 46svh, 460px);
    padding-bottom: env(safe-area-inset-bottom, 0);
  }

  @media (max-width: 420px) {
    height: clamp(280px, 44svh, 420px);
  }
`;

export const Guard = styled.div`
  position: absolute;
  inset: 0;
  z-index: 5;
  background: rgba(11, 11, 11, 0.24);
  display: grid;
  place-items: end center;
  padding: 18px;
  cursor: zoom-in;
  user-select: none;

  &::after {
    content: "Click pentru a activa harta";
    background: rgba(255, 255, 255, 0.94);
    color: ${c.ink};
    border: 1px solid rgba(11, 11, 11, 0.12);
    border-radius: 999px;
    padding: 10px 14px;
    margin-bottom: 12px;
    font-size: clamp(12px, 1.8vw, 14px);
    letter-spacing: 0.06em;
  }

  &:focus {
    outline: 2px solid rgba(201, 162, 39, 0.7);
    outline-offset: -2px;
  }
`;

export const Chip = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 6;
  background: rgba(255, 255, 255, 0.92);
  color: ${c.ink};
  border: 1px solid rgba(11, 11, 11, 0.12);
  border-radius: 999px;
  padding: 8px 12px;
  font-size: 12px;
  letter-spacing: 0.06em;
  pointer-events: none;
`;

export const OverlayCard = styled.div`
  position: absolute;
  left: clamp(12px, 6%, 40px);
  bottom: clamp(12px, 8%, 40px);
  background: rgba(255, 255, 255, 0.94);
  color: ${c.ink};
  border-radius: 18px;
  padding: 14px 16px;
  width: min(520px, 88vw);
  border: 1px solid rgba(11, 11, 11, 0.12);
  z-index: 4;

  /* linie discretă aur/roz jos */
  box-shadow: 0 0 0 1px rgba(201, 162, 39, 0.08) inset;

  &:after {
    content: "";
    display: block;
    margin-top: 10px;
    height: 1px;
    width: 100%;
    background: linear-gradient(90deg, ${c.gold}, ${c.pink}, transparent);
    opacity: 0.85;
  }

  @media (max-width: 720px) {
    left: 10px;
    right: 10px;
    bottom: 10px;
    width: auto;
  }

  p {
    margin: 6px 0 0;
    color: rgba(11, 11, 11, 0.72);
    line-height: 1.5;
  }
`;

export const PinTitle = styled.h3`
  margin: 0 0 2px;
  font-size: clamp(18px, 2.2vw, 22px);
  letter-spacing: 0.02em;
`;
